//
// Copyright (c) 2011-2018 by Curalate, Inc.
//

import angular from 'angular';
import _ from 'underscore';

import template from './showroom-settings-custom-strings.html';

import { debounce } from '@utils/debounce';

class ShowroomSettingsCustomStrings {
  public customStringsState;
  public customStringsPanelOpen: boolean;

  public trackingCategory: string;
  public trackingAction: string;
  public trackingLabels;

  public customStringsChanged = {};
  public onCustomStringChanged = debounce((section) => {
    if (!this.customStringsChanged[section]) {
            // Since the string fields are updated live, we will only log a GA event once
            // per string per "session" where a session is defined by:
            // 1) a fresh load of the Add Ons panel or
            // 2) a toggle of the custom strings panel
      this.customStringsChanged[section] = true;
      this.TrackingService.recordEvent(
                this.trackingCategory,
                this.trackingAction,
                this.trackingLabels.customStringUpdated(section),
            );
    }
    this.ShowroomService.updateCustomStringState(
            this.sanitizedCustomStringState(),
            this.getSectionToUpdate(section),
        );
  }, 200);

  constructor(
        private UniversalImageActionsService,
        private ShowroomService,
        private TrackingService,
        private SHOWROOM_PREVIEW_SECTIONS,
    ) { }

  public onCustomStringsToggled = () => {
    this.customStringsPanelOpen = !this.customStringsPanelOpen;
    this.customStringsChanged = {};

    this.TrackingService.recordEvent(
            this.trackingCategory,
            this.trackingAction,
            this.trackingLabels.toggleEmailCapture(this.customStringsPanelOpen),
        );
  }

  public $onInit() {
    const launchOptions = this.UniversalImageActionsService.getCurrentLaunchOptions();
    const universalItemId = launchOptions.getUniversalItemId();

    this.trackingCategory = this.ShowroomService.getTrackingCategory();
    this.trackingAction = this.ShowroomService.getTrackingAction();
    this.trackingLabels = {
      toggleEmailCapture: (open) => (open) ? 'CustomStringsPanelOpened' : 'CustomStringsPanelClosed',
      customStringUpdated: (section) => `CustomStringUpdated:${section}`,
    };

    this.ShowroomService.getCurrentConfigStatusObservable().subscribe((currentState) => {
      const state = angular.copy(currentState);
      this.customStringsState = _(this.customStringsState || {}).extend(state.customStringsState);
    });
    this.ShowroomService.loadExistingState(universalItemId);
  }

  private sanitizedCustomStringState = () => {
    const safeState = {};
    _(this.customStringsState).each((val: any, key)  => {
      safeState[key] = val.trim();
    });
    return safeState;
  }

  private getSectionToUpdate = (section) => {
    switch (section) {
      case 'shopTheLook': return this.SHOWROOM_PREVIEW_SECTIONS.TAGGED_PRODUCTS;
      case 'relatedItems': return this.SHOWROOM_PREVIEW_SECTIONS.MEDIA;
      case 'recommendedProducts': return this.SHOWROOM_PREVIEW_SECTIONS.PRODUCTS;
      default: return this.SHOWROOM_PREVIEW_SECTIONS.NONE;
    }
  }
}

angular.module('uia').component('showroomSettingsCustomStrings', {
  template,
  controller: [
    'UniversalImageActionsService',
    'ShowroomService',
    'TrackingService',
    'SHOWROOM_PREVIEW_SECTIONS',
    ShowroomSettingsCustomStrings,
  ],
});
